<template>
    <table>
        <tr>
            <td class="piegraph">
                <CircularProgressBar :percentage="completion" :size="46" :strokeWidth="24"/>
            </td>
            <td class="report">
                <table>
                    <tr>
                        <td class="archivo-subido">
                            <span v-if="fileData.remuneraciones">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.remuneraciones" />
                            </span>
                        </td>
                        <td class="archivo-subido">
                            <span v-if="fileData.facturas_extranjeras">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.facturas_extranjeras" />
                            </span>
                        </td>
                        <td class="archivo-subido">
                            <span v-if="fileData.recibos">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.recibos" />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="archivo-subido">
                            <span v-if="fileData.finiquitos">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.finiquitos" />
                            </span>
                        </td>
                        <td class="archivo-subido">
                            <span v-if="fileData.exportable_erp">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.exportable_erp" />
                            </span>
                        </td>
                        <td class="archivo-subido">
                            <span v-if="fileData.creditos">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.creditos" />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="archivo-subido">
                            <span v-if="fileData.balance_8_columnas">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.balance_8_columnas" />
                            </span>
                        </td>
                        <td class="archivo-subido">
                            <span v-if="fileData.libro_bancos">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.libro_bancos" />
                            </span>
                        </td>
                        <td class="archivo-subido">
                            <span v-if="fileData.data_operacional_complementaria">
                                <FileCheckBox onClick="return false;" :dataRow="fileData.data_operacional_complementaria" />
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="archivo-subido">
                        </td>
                        <td class="archivo-subido">
                        </td>
                        <td class="archivo-subido">
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</template>

<script>
import FileCheckBox from "@/components/analystPanel/FileCheckBox";
import CircularProgressBar from "@/components/analystPanel/CircularProgressBar";

export default {
  name: 'FileCompletionTable',
    components: {
        FileCheckBox,
        CircularProgressBar,
    },
    props: {
        fileData: {
            type: Object,
            required: true,
            default: () => ({})
        },
        completion: {
            type: Number,
            default: 0,
        }
    },
}
</script>
<style scoped>
.archivo-subido {
    width: 2em !important;
    font-size: 0.9em;
    text-align: left;
    vertical-align: middle;
}
.piegraph {
    vertical-align: middle;
    padding-left: 15px !important;
}
.report {
    padding: 5px 0 5px 10px !important;
}
</style>